import { render } from "./SubsExtractForm.vue?vue&type=template&id=698a76b9&scoped=true"
import script from "./SubsExtractForm.vue?vue&type=script&lang=js"
export * from "./SubsExtractForm.vue?vue&type=script&lang=js"

import "./SubsExtractForm.vue?vue&type=style&index=0&id=698a76b9&scoped=true&lang=scss"

import exportComponent from "/Users/eduardopassos/Documents/Dev/blat/subsextract/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698a76b9"]])

export default __exports__